export const copy = {
  steps: ['Basic Info', 'Choose your service', 'Billing + payment', 'Choose provider + book a session']
};
